<template>
  <div>
    <v-card-title>
      <v-row class="py-2">
        <!-- <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select
            class="px-4"
            v-model="tipoCampamento"
            :items="tipoCampamentoOpciones"
            label="Tipo Campamento"
            @change="seleccionTipoCampamento($event)"
          ></v-select>
        </v-col> -->
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="sector" :items="sectorOpciones" label="Sector"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="bloque" :items="bloqueOpciones" label="Bloque"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="aldea" :items="aldeaOpciones" label="Aldea"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="carpa" :items="carpaOpciones" label="Carpa"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="sexo" :items="sexoOpciones" label="Sexo"></v-select>
        </v-col>
        <v-col lg="4" md="4" sm="4" class="col-12">
          <v-select class="px-4" v-model="filtro" :items="filtroOpciones" label="Filtro"></v-select>
        </v-col>
        <!-- <v-spacer></v-spacer>
        <v-col lg="2" md="2" sm="2" class="col-12">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-4" v-on="on" fab dark small color="green" @click="agregar()">
                <v-icon small dark>fas fa-plus</v-icon>
              </v-btn>
            </template>
            <span>Importar</span>
          </v-tooltip>
        </v-col> -->
      </v-row>
    </v-card-title>
    <v-data-table
      v-model="seleccionado"
      :headers="headers"
      :items="listadoCampamento"
      class="elevation-0 border"
      :single-select="singleSelect"
      item-key="idunidadcampamento"
      show-select
      multi-sort
      :mobile-breakpoint="0"
      no-data-text="No se encontraron datos"
      no-results-text="No se encontraron datos"
      :items-per-page="pagina"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="text-center">
            <v-menu bottom offset-y ref="openMenu">
              <template v-slot:activator="{ on: menu }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn class="mx-2" fab small color="primary" v-on="{ ...tooltip, ...menu }">
                      <v-icon small>fas fa-ellipsis-v</v-icon>
                    </v-btn>
                  </template>
                  <span>Acciones</span>
                </v-tooltip>
              </template>
              <v-list>
                <v-list-item @click.stop="cambiarEstado('H')">
                  <v-list-item-title> Habilitar </v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="cambiarEstado('D')">
                  <v-list-item-title> Deshabilitar </v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="cambiarEstado('M')">
                  <v-list-item-title> Cambiar Masculino </v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop="cambiarEstado('F')">
                  <v-list-item-title> Cambiar Femenino </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.activo="{ item }">
        <v-icon color="#FFAB00" small v-if="item.activo == 0">fas fa-square-full</v-icon>
        <v-icon color="green" small v-else-if="item.activo == 1">fas fa-square-full</v-icon>
        <v-icon color="red" small v-else-if="item.activo == 2">fas fa-square-full</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="300">
      <v-card>
        <v-card-title class="headline">Mensaje Informativo</v-card-title>
        <v-card-text> Las camas ocupadas no se pueden cambiar de estado a {{ txtEstado }} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="dialog = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="2000" :color="color">
      {{ text }}
      <v-btn :color="color == 'red' ? 'white' : 'primary'" text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import GestionService from '../services/GestionService';
/* import listTable from '../services/campamento'; */
export default {
  name: 'GestionLista',
  data: () => ({
    snackbar: false,
    color: '',
    text: '',
    dialog: false,
    singleSelect: false,
    seleccionado: [],
    gestionService: null,
    filtro: '',
    filtroOpciones: [
      { text: 'TODOS', value: '' },
      { text: 'HABILITADOS', value: '1' },
      { text: 'OCUPADOS', value: '0' },
      { text: 'DESHABILITADOS', value: '2' }
    ],
    sexo: '',
    sexoOpciones: [
      { text: 'TODOS', value: '' },
      { text: 'FEMENINO', value: 'F' },
      { text: 'MASCULINO', value: 'M' }
    ],
    sector: '',
    sectorOpciones: [],
    tipoCampamento: '',
    tipoCampamentoOpciones: [],
    bloque: '',
    bloqueOpciones: [],
    aldea: '',
    aldeaOpciones: [],
    carpa: '',
    carpaOpciones: [],
    headers: [
      { text: 'tipocampamento', value: 'idtipocampamento' },
      { text: 'sector', value: 'idsectorpadre' },
      { text: 'bloque', value: 'idsector' },
      { text: 'aldea', value: 'aldea' },
      { text: 'carpa', value: 'carpa' },
      { text: 'habitacion', value: 'habitacion' },
      { text: 'cama', value: 'cama' },
      { text: 'sexo', value: 'sexo' },
      { text: 'activo', value: 'activo', align: 'center' }
    ],
    listadoCampamento: [],
    cont: 0,
    txtEstado: ''
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    }
  },
  watch: {
    async sector(val) {
      this.iniciaBloque(val);
    },
    bloque(val) {
      if (val != '') {
        this.iniciaAldea(val);
      }
    },
    aldea(val) {
      if (val != '') {
        this.iniciaCarpa(val);
      }
    },
    carpa(val) {
      if (val != '') {
        this.iniciaListado();
      }
    },
    sexo() {
      if (this.carpa != '') {
        this.iniciaListado();
      }
    },
    filtro() {
      if (this.carpa != '') {
        this.iniciaListado();
      }
    }
  },
  methods: {
    open() {
      this.$emit('open');
    },
    close() {
      this.$emit('close');
    },
    async iniciaListado() {
      this.open();
      this.listadoCampamento = [];
      const res = await this.gestionService.get().execResource('unidadcampamento', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        idaldea: this.aldea,
        idcarpa: this.carpa,
        sexo: this.sexo,
        activo: this.filtro
      });
      if (res.length > 0) {
        this.listadoCampamento = res;
        this.close();
      }
      this.close();
    },
    async iniciaBloque(env) {
      this.open();
      this.bloque = '';
      this.bloqueOpciones = [];
      const res = await this.gestionService.get().execResource('sectores', {
        idsectorpadre: env
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.bloqueOpciones.push({ text: element.idsector, value: element.idsector });
        });
        this.bloque = this.bloqueOpciones[0].value;
      }
    },
    async iniciaSectorPadre() {
      this.open();
      this.sector = '';
      this.sectorOpciones = [];
      const res = await this.gestionService.get().execResource('sectoresPadres', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.sectorOpciones.push({ text: element.idsectorpadre, value: element.idsectorpadre });
        });
        this.sector = this.sectorOpciones[0].value;
      } else {
        this.close();
      }
    },
    async iniciaAldea(env) {
      this.open();
      this.aldea = '';
      this.aldeaOpciones = [];
      const res = await this.gestionService.get().execResource('aldeas', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: env
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.aldeaOpciones.push({ text: element.idaldea, value: element.idaldea });
        });
        this.aldea = this.aldeaOpciones[0].value;
      }
    },
    async iniciaCarpa(env) {
      this.open();
      this.carpa = '';
      this.carpaOpciones = [];
      const res = await this.gestionService.get().execResource('carpas', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        idaldea: env
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.carpaOpciones.push({ text: element.idcarpa, value: element.idcarpa });
        });
        this.carpa = this.carpaOpciones[0].value;
      }
    },
    ocupadoSearch(data, text) {
      this.cont = 0;
      if (data.length > 0) {
        data.forEach((element) => {
          if (element.activo == 0) {
            this.cont++;
          }
        });
        if (this.cont > 0) {
          this.dialog = true;
          this.txtEstado = text;
        }
      }
      this.seleccionado = [];
    },
    async consultaApiEstado(data, val, apiname) {
      const res = await this.gestionService.put().execResource(apiname, {
        data: data,
        value: val
      });
      if (res.status) {
        this.iniciaListado();
      }
      this.seleccionado = [];
    },
    cambiarEstado(val) {
      const aux = [];
      this.seleccionado.forEach((element) => {
        aux.push(element.idunidadcampamento);
      });
      if (aux.length > 0) {
        switch (val) {
          case 'H':
            this.consultaApiEstado(aux, '1', 'estado');
            this.ocupadoSearch(this.seleccionado, 'Habilitado');
            break;
          case 'D':
            this.consultaApiEstado(aux, '2', 'estado');
            this.ocupadoSearch(this.seleccionado, 'Deshabilitado');
            break;
          case 'F':
            this.consultaApiEstado(aux, 'F', 'sexo');
            this.ocupadoSearch(this.seleccionado, 'Femenino');
            break;
          case 'M':
            this.consultaApiEstado(aux, 'M', 'sexo');
            this.ocupadoSearch(this.seleccionado, 'Masculino');
            break;
        }
      } else {
        this.snackbar = true;
        this.text = 'Seleccione al menos un elemento de la lista.';
        this.color = 'red';
      }
      this.$refs.openMenu.isActive = false;
    },
    agregar() {
      this.$router.push({ path: '/campamento/asignacion/asignar' });
    }
  },
  async mounted() {
    this.gestionService = this.$httpService(new GestionService(), this);
    //await this.inciaTipoCampamento();
    this.filtro = this.filtroOpciones[1].value;
    await this.iniciaSectorPadre();
  }
};
</script>
